import moment from "moment";
import { AiOutlineDownload } from "react-icons/ai";
import { Col, Collapse, Row, Typography } from "antd";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import Button from "../Button";
import { StyledTable, VendasContainer } from "./styles";
import { download, formatCurrency, numberToPercentage, numberToPercentageWallet } from "../../utils";
import { useDarfExterior } from "./useOperationModal";

interface IBolsaProps {
  transaction: any;
  index: number;
  setIndex: React.Dispatch<React.SetStateAction<number>>;
}

const calcReturn = (
  sellPrice: number,
  buyPrice: number,
  quantity: number,
  fee: number,
  ganho?: number
) => {
  let ret = 0
  if(ganho) {
    const qtt = quantity ? quantity : 1;
    ret =
    sellPrice && buyPrice
    ? (sellPrice * qtt - (fee || 0)) / (buyPrice * qtt) - 1
    : 0;
  }
  return (
    <strong
      style={{
        color: `${ret >= 0
          ? "green"
          : "red"
          }`,
      }}
    >
      {ret ? numberToPercentageWallet(ret) : "-"}
    </strong>
  );
};

export const TabelasBolsa = ({ transaction, index, setIndex }: IBolsaProps) => {
  const dtoBolsa = [
    {
      title: "Comum",
      Resultado: "varTotaisComum",
      "Ganhos tributáveis": "ganhoComum",
      "(-) Prejuízos a compensar": "prejuizoComum",
      "(x) Alíquota devida": "15%",
      "Imposto devido": "impostoComumFinal",
    },
    {
      title: "Day Trade",
      Resultado: "varTotaisDT",
      "Ganhos tributáveis": "ganhoDT",
      "(-) Prejuízos a compensar": "prejuizoDayTrade",
      "(x) Alíquota devida": "20%",
      "Imposto devido": "impostoDTFinal",
    },
    {
      title: "FII",
      Resultado: "varTotaisFII",
      "Ganhos tributáveis": "ganhoFII",
      "(-) Prejuízos a compensar": "prejuizoFII",
      "(x) Alíquota devida": "20%",
      "Imposto devido": "impostoFIIFinal",
    },
  ];

  const handleDownloadSheetByLink = async (link: string) => {
    download(link);
  };

  return (
    <>
      <StyledTable>
        <Row className="columnTitle">
          {dtoBolsa.map((t, i) => (
            <Col span={5} className={index === i ? "show" : "hide"}>
              <BiChevronLeft
                className={`chevronIcon ${index === 0 ? "transparent" : ""}`}
                onClick={() => {
                  if (index > 0) setIndex(index - 1);
                }}
              />
              {t.title}
              <BiChevronRight
                className={`chevronIcon ${
                  index === dtoBolsa.length - 1 ? "transparent" : ""
                }`}
                onClick={() => {
                  if (index < dtoBolsa.length - 1) setIndex(index + 1);
                }}
              />
            </Col>
          ))}
        </Row>
        <Row className="operationsRow">
          <Col className="rowLabel">Resultado</Col>
          {dtoBolsa.map((t, i) => (
            <Col span={5} className={index === i ? "show" : "hide"}>
              {formatCurrency(transaction?.[t.Resultado])}
            </Col>
          ))}
        </Row>
        <Row className="operationsRow">
          <Col className="rowLabel">Ganhos tributáveis</Col>
          {dtoBolsa.map((t, i) => (
            <Col span={5} className={index === i ? "show" : "hide"}>
              {formatCurrency(transaction?.[t["Ganhos tributáveis"]])}
            </Col>
          ))}
        </Row>
        <Row className="operationsRow">
          <Col className="rowLabel">(-) Prejuízos a compensar</Col>
          {dtoBolsa.map((t, i) => (
            <Col span={5} className={index === i ? "show" : "hide"}>
              {formatCurrency(transaction?.[t["(-) Prejuízos a compensar"]])}
            </Col>
          ))}
        </Row>
        <Row className="operationsRow">
          <Col className="rowLabel">(x) Alíquota devida</Col>
          {dtoBolsa.map((t, i) => (
            <Col span={5} className={index === i ? "show" : "hide"}>
              {t["(x) Alíquota devida"]}
            </Col>
          ))}
        </Row>
        <Row className="operationsRow">
          <Col className="rowLabel">Imposto devido</Col>
          {dtoBolsa.map((t, i) => (
            <Col span={5} className={index === i ? "show" : "hide"}>
              {formatCurrency(transaction?.[t["Imposto devido"]])}
            </Col>
          ))}
        </Row>
      </StyledTable>

      <Collapse
        ghost
        bordered={false}
        expandIconPosition="end"
        className="operationsCollapse"
      >
        <Collapse.Panel
          key="1"
          header={
            <Typography.Title level={5} style={{ fontSize: "20px" }}>
              Vendas realizadas no mês
            </Typography.Title>
          }
        >
          {transaction?.memoriaCalculo?.length > 0 && (
            <Button
              type="link"
              onClick={() =>
                handleDownloadSheetByLink(transaction?.sheetFileUrl)
              }
              style={{
                fontSize: "14px",
                marginBottom: "16px",
              }}
              icon={
                <AiOutlineDownload
                  style={{
                    width: "16px",
                    height: "16px",
                  }}
                />
              }
            >
              BAIXAR PLANILHA
            </Button>
          )}
          <VendasContainer>
            {transaction?.memoriaCalculo?.length > 0 ? (
              (transaction?.memoriaCalculo || []).map((op: any, i: number) => {
                const retorno =
                  op?.sellPrice && op?.buyPrice
                    ? op?.sellPrice / op?.buyPrice - 1
                    : 0;
                return (
                  <Row
                    style={{
                      marginBottom:
                        i === transaction?.memoriaCalculo?.length - 1
                          ? "0"
                          : "1.5rem",
                    }}
                  >
                    <Col span={24}>
                      <Row id="title">{op?.code}</Row>
                      <Row>Data: {moment(op?.date).format("DD/MM/YYYY")}</Row>
                      <Row>Quantidade: {op?.quantity}</Row>
                      <Row>
                        <Typography.Text style={{ marginRight: "4px" }}>
                          Ganho:
                        </Typography.Text>
                        {formatCurrency(op?.capitalGain)}
                      </Row>
                      <Row>
                        Retorno:
                        <Typography.Text
                          style={{
                            color: retorno > 0 ? "green" : "red",
                            marginLeft: "4px",
                          }}
                        >
                          {numberToPercentage(retorno)}
                        </Typography.Text>
                      </Row>
                    </Col>
                  </Row>
                );
              })
            ) : (
              <div style={{ textAlign: "center" }}>
                Nenhuma operação de venda realizada neste mês
              </div>
            )}
          </VendasContainer>
        </Collapse.Panel>
      </Collapse>
    </>
  );
};

export const TabelasExterior = ({ transaction, oldModel, year }: { transaction: any, oldModel: boolean, year?: number }) => {
  const style = (i: any) => ({
    marginBottom:
      i ===
        (transaction?.memoriaCalculo || []).filter(
          (op: any) => op?.type !== "DIVIDEND"
        ).length -
        1
        ? "0"
        : "1.5rem",
  })
  const { getBuyPrice, getFee, getGain, getSellPrice } = useDarfExterior()

  const ExteriorFields = ({op, i}: {op: any, i: any}) => (
    <Row style={style(i)}>
      <Col span={24}>
        <Row id="title">{op?.ativo}</Row>
        <Row>
          Data de liquidação:{" "}
          {moment(op?.data).format("DD/MM/YYYY")}
        </Row>
        <Row>
          <Typography.Text style={{ marginRight: "4px" }}>
            Ganho:
          </Typography.Text>
          {formatCurrency(
            op?.type === "INTEREST"
              ? op?.rendimentoAplicacao
              : op?.ganho
          )}
        </Row>
      </Col>
    </Row>
  )

  const ExteriorFieldsNew = ({op, i}: {op: any, i: any}) => {
    const isTrade = op?.type === "TRADE";
    return (
      <Row style={style(i)}>
        <Col span={24}>
          <Row id="title">{op?.ativo}</Row>
          <Row>
            Data:{" "}
            {moment(op?.data).format("DD/MM/YYYY")}
          </Row>
          {
            (isTrade && !oldModel) && (
              <Row>
                <Typography.Text style={{ marginRight: "4px" }}>
                  Quantidade:
                </Typography.Text>
                {formatCurrency(op?.quantidade)}
              </Row>
            )
          }
          <Row>
            <Typography.Text style={{ marginRight: "4px" }}>
              {isTrade ? 'Ganho:' : 'Rendimento total:'}
            </Typography.Text>
            {formatCurrency((() => {
              if (oldModel) {
                return op?.type === "INTEREST"
                ? op?.rendimentoAplicacao
                : op?.varTotalBRL
              }
              switch(op?.type) {
                case 'DIVIDEND':
                case 'INTEREST':
                  return op?.rendimentoAplicacao;
                default:
                  return op?.varTotalBRL
              }
            })()
            )}
          </Row>
          {
            (isTrade && !oldModel) && (
              <Row>
                <Typography.Text style={{ marginRight: "4px" }}>
                  Retorno:
                </Typography.Text>
                {calcReturn(
                  getSellPrice(op, oldModel).value,
                  getBuyPrice(op, oldModel).value,
                  op?.quantidade,
                  getFee(op, oldModel).value,
                  getGain(op, oldModel).value
                )}
              </Row>
            )
          }
        </Col>
      </Row>
    )
  }

  return (
    <>
      {year && year <= 2023 && <StyledTable>
        <Row className="operationsRow" style={{ height: "40px" }}>
          <Col className="rowLabel">Ganho total</Col>
          <Col span={10} className="show">
            {formatCurrency(transaction?.totalGanho)}
          </Col>
        </Row>
        <Row className="operationsRow" style={{ height: "40px" }}>
          <Col className="rowLabel">(x) Alíquota devida</Col>
          <Col span={10} className="show">
            {Number.isInteger(transaction?.aliquotaDevida)
              ? transaction?.aliquotaDevida
              : transaction?.aliquotaDevida?.toFixed(2)}{" "}
            %
          </Col>
        </Row>
        <Row className="operationsRow" style={{ height: "40px" }}>
          <Col className="rowLabel">Imposto devido</Col>
          <Col span={10} className="show">
            {formatCurrency(transaction?.impostoDevido)}
          </Col>
        </Row>
      </StyledTable>}
      <Collapse
        ghost
        bordered={false}
        expandIconPosition="end"
        className="operationsCollapse"
      >
        <Collapse.Panel
          key="1"
          header={
            <Typography.Title level={5} style={{ fontSize: "20px" }}>
              {year && year <= 2023 ? 'Vendas realizadas no mês' : 'Movimentações'}
            </Typography.Title>
          }
        >
          <VendasContainer>
            {transaction?.memoriaCalculo?.length > 0 ? (
              (transaction?.memoriaCalculo || [])
                .filter(
                  (op: any) =>
                    (op?.type === "WITHDRAW" && op?.operation === "SELL") ||
                    (op?.type === "TRADE" && op?.operation === "SELL") ||
                    (op?.type === "INTEREST" && op?.operation === "BUY") ||
                    (op?.type === "DIVIDEND" && !oldModel)
                )
                .map((op: any, i: number) => {
                  if(!oldModel) return <ExteriorFieldsNew op={op} i={i} />
                  return (
                    <ExteriorFields op={op} i={i}/>
                  );
                })
            ) : (
              <div style={{ textAlign: "center" }}>
                Nenhuma operação de venda realizada neste mês
              </div>
            )}
          </VendasContainer>
        </Collapse.Panel>
      </Collapse>
    </>
  );
};
